<template>
  <div class="box">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>我的公益</span>
      </div>
    </div>
    <div class="my_top">
      <div class="my_top_user">
        <img :src="userinfo.image" alt="" />
        <div class="user">
          <div class="user_name">{{ userinfo.name }}</div>
          <div class="user_position">{{ userinfo.department }}</div>
        </div>
      </div>
      <div class="text">TA本年度获得的公益徽章</div>
      <div
        class="badge_content"
        @click="handleToMyBadge"
        v-if="badgeList.length > 0"
      >
        <div
          class="badge_item"
          v-for="(item, index) in badgeList"
          :key="index"
          :class="
            index == 0 && item.name
              ? 'badge_item1'
              : index == 1 && item.name
              ? 'badge_item2'
              : index == 2 && item.name
              ? 'badge_item3'
              : ''
          "
        >
          <img
            :src="item.icon"
            alt=""
            style="width: 14px; height: 14px"
            v-if="item.name"
          />
          <span class="name">{{ item.name }}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="badge_content" @click="handleToMyBadge" v-else>
        <div class="badge_item" style="font-size: 17px">暂未获得</div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="my_tab">
        <div class="tab_item">
          <div>累计时长</div>
          <div>{{ userinfo.hour }}h</div>
        </div>
        <div class="tab_item">
          <div>爱心行为</div>
          <div>{{ userinfo.num }}次</div>
        </div>
        <div class="tab_item" @click="toRouter('/mobile/medal/benefitRank')">
          <div>部门排行</div>
          <div>{{ userinfo.rank }}名</div>
        </div>
        <div class="tab_item">
          <div>近期公益</div>
          <div v-if="userinfo.lastTime">{{ userinfo.lastTime }}</div>
          <div v-else>暂无</div>
        </div>
      </div>
      <!-- v-if="approveList.length > 0" -->
      <div
        class="badge_content"
        style="margin-top: 15px"
        @click="toRouter('/mobile/medal/publicWelfare/approveRecord')"
        v-if="approveList.length > 0"
      >
        <div style="font-size: 17px">我的审批</div>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="my_con">
      <div class="title">
        <div></div>
        <div>TA的公益历程</div>
        <div></div>
      </div>
      <van-steps
        class="steps"
        direction="vertical"
        :active="-1"
        v-if="historyList.length > 0"
      >
        <van-step v-for="(v, i) in historyList" :key="i">
          <div>{{ v.enterTime }}</div>
          <div v-if="v.type == 1">
            参加{{ v.epbActivityName }},获得公益时长{{ v.hour ? v.hour + "h" : 0 + "h" }}
          </div>
          <div v-if="v.type == 2">
            个人提报“{{optionType[Number(v.pbType) - 1]?.name}}”获得公益时长{{v.hour ? v.hour : 0}}h
          </div>
        </van-step>
      </van-steps>
      <div class="steps" style="text-align: center; font-size: 15px" v-else>
        暂无历史进程
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
// import apiLogin from "@/apis";
import apis from "@/apis/publicWelfare";
import { getToken } from "@/utils/cookie";
import moment from "moment";
export default {
  name: "my",
  props: {},
  components: {},
  data() {
    return {
      badgeList: [
        {
          icon: require("@/assets/newsNotice/icon1.png"),
          name: "",
        },
        {
          icon: require("@/assets/newsNotice/icon2.png"),
          name: "",
        },
        {
          icon: require("@/assets/newsNotice/icon3.png"),
          name: "",
        },
      ],
      // empno: "",
      stepList: [],
      userinfo: {},
      historyList: [],
      approveList: [],
      optionType:[]
    };
  },

  created() {},
  computed: {},
  mounted() {
    this.getLastThreeMedals();
    this.getUserinfo();
    this.queryHistoryRecord();
    this.getHistory();
    this.getSelect()
    // let hrToken = getToken();
    // if (hrToken) {
    //   this.empno = hrToken;
    //   this.getLastThreeMedals(hrToken);
    //   // this.likeLog();
    // } else {
    //   this.$bus.$on("processToken", (res) => {
    //     Promise.resolve(this.getHrToken(res)).then(() => {
    //       this.empno = res;
    //       this.getLastThreeMedals(res);
    //       // this.likeLog();
    //     });
    //   });
    // }
  },
  beforeDestroy() {},
  methods: {
    // getHrToken(username) {
    //   return new Promise((resolve) => {
    //     if (username) {
    //       let thisname = username;

    //       if (thisname === "17625010228" || thisname === "17637403245") {
    //         thisname = "10005038";
    //       } else if (thisname === "15093054787") {
    //         thisname = "10005038";
    //       }

    //       apiLogin.getUserToken({ username: thisname }).then((data) => {
    //         const info = data.data;
    //         window.sessionStorage.hrToken = info.auth_token;
    //         resolve();
    //       });
    //     } else {
    //       resolve();
    //     }
    //   });
    // },
    //获取提报类型
    getSelect() {
      apis.getTypeList().then((res) => {
        if (res.code == 200) {
          console.log(res, "res");
          this.optionType = res.data;
        }
      });
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    //获取用户信息
    getUserinfo() {
      apis.myPubBenefit({ empNo: getToken() }).then((res) => {
        if (res.code == 200) {
          this.userinfo = res.data;
          if (this.userinfo.lastTime) {
            this.userinfo.lastTime = moment(this.userinfo.lastTime).format(
              "YYYY/MM/DD"
            );
          }
        }
      });
    },
    //获取最近三个徽章
    getLastThreeMedals() {
      apis.getLastThreeMedals({ empNo: getToken() }).then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            res.data.forEach((item, index) => {
              this.badgeList[index].name = item.medalName;
            });
          } else {
            this.badgeList = [];
          }
        }
      });
    },
    //获取徽章
    handleToMyBadge() {
      api
        .myBadgeApi({
          cardType: 4,
          empno: getToken(),
          id: "",
        })
        .then((res) => {
          const id = res.data[0]?.id;
          localStorage.setItem("tabValue", JSON.stringify(id ? id : 0));
          this.$router.push("/mobile/medal/myBadgeList");
        });
    },
    //获取历史记录
    getHistory() {
      apis
        .history({ empNo: getToken(), type: 0, state: 2, isSettle: 1 })
        .then((res) => {
          if (res.code == 200) {
            this.historyList = res.data;
            this.historyList.forEach((item) => {
              item.enterTime = item.enterTime ? moment(item.enterTime).format("YYYY-MM-DD") : "暂无";
            });
          }
        });
    },
    //获取审批记录
    queryHistoryRecord() {
      apis
        .myAudit({
          empNo: getToken(),
          state: 0,
        })
        .then((res) => {
          if (res.code == 200) {
            this.approveList = res.data;
          }
        });
    },
    //跳转详情
    toRouter(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.box {
  padding: 30px;
  .goback {
    margin: 10px 40px 40px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
    }

    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 40px;
    }

    span {
      font-size: 34px;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .my_top {
    width: 100%;
    // height: 200px * $zoom;
    padding: 30px 30px 50px;
    border-radius: 25px;
    background: #fff;
    margin-top: 80px;
    position: relative;
    .my_top_user {
      display: flex;
      align-items: center;
      img {
        border-radius: 50%;
        border: 6px solid #fff;
        width: 50px * $zoom;
        height: 50px * $zoom;
        margin-top: -55px;
      }
      .user {
        margin-left: 30px;
        .user_name {
          font-size: 11px * $zoom;
          color: #000;
          margin-bottom: 15px;
        }
        .user_position {
          font-size: 10px * $zoom;
          color: #666;
          margin-bottom: 15px;
        }
      }
    }
    .text {
      color: #999999;
      font-size: 10px * $zoom;
      margin: 20px 0;
    }
    .badge_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      display: flex;
      i {
        font-size: 38px;
      }
      // justify-content: space-around;
      .badge_item {
        font-size: 22px;
        border-radius: 22px;
        padding: 10px 15px;
        display: flex;
        align-items: center;
        // margin-top: 15px;
        // margin-left: 30px;
        .name {
          margin-left: 10px;
        }
      }
      .badge_item1 {
        background: #faf7ea;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        color: #ff9347;
      }
      .badge_item2 {
        background: #f2f7fc;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        color: #666666;
      }
      .badge_item3 {
        background: #f8f6f4;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        color: #b97e61;
      }
      .opImg {
        opacity: 0;
      }
      .oImg {
        opacity: 1;
      }
    }
    .my_tab {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tab_item {
        div:nth-child(1) {
          color: #999;
          font-size: 10px * $zoom;
          text-align: center;
        }
        div:nth-child(2) {
          color: #000;
          font-size: 12px * $zoom;
          font-weight: bold;
          margin-top: 20px;
          text-align: center;
        }
      }
    }
  }
  .my_con {
    width: 100%;
    // height: 45.5vh;
    padding: 30px 30px 50px;
    border-radius: 25px;
    background: #fff;
    margin-top: 30px;
    position: relative;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      div:nth-child(1),
      div:nth-child(3) {
        background: #000;
        width: 50px;
        height: 2px;
      }
      div:nth-child(2) {
        color: #000;
        font-size: 12px * $zoom;
        margin: 0 20px;
      }
    }
    .steps {
      // height: 36vh;
      margin-top: 30px;
      ::v-deep {
        .van-step__circle {
          background: #4ea27c;
          width: 15px;
          height: 15px;
        }
        .van-step {
          margin-bottom: 15px;
        }
        .van-step__title {
          div:nth-child(1) {
            font-size: 10px * $zoom;
            color: #666;
            margin-bottom: 12px;
          }
          div:nth-child(2) {
            font-size: 11px * $zoom;
            color: #000;
          }
        }
        .van-step--vertical:not(:last-child)::after {
          border: none !important;
        }
      }
    }
  }
}
</style>
